import { render } from "./ThoughtInCommentList.vue?vue&type=template&id=c38a6ebc&scoped=true"
import script from "./ThoughtInCommentList.vue?vue&type=script&lang=js"
export * from "./ThoughtInCommentList.vue?vue&type=script&lang=js"

import "./ThoughtInCommentList.vue?vue&type=style&index=0&id=c38a6ebc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c38a6ebc"]])

export default __exports__